<template>
  <div>
    <v-dialog v-model="showQualification" width="950" persistent>
      <v-card class="pb-4">
        <v-card-title class="primary">
          <span class="white--text">Service Qualification</span>
        </v-card-title>
        <v-card-text class="subtitle-1 pb-0 mt-6">
          <qualification-result
            ref="qualificationResult"
            :showHeading="false"
            :enable="true"
            :showButtons="true"
            :hideOtherButtons="true"
            :queryAddress="queryAddress"
            :hasMultipleLocId="false"
            @qualification="qualification"
            @cancel="$emit('cancel')"
            @createOrder="createOrder"
          ></qualification-result>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "QualificationDialog",
  props: {
    showQualification: { type: Boolean },
    queryAddress: { type: Array }
  },
  methods: {
    qualification(id){
      let vm = this;
      vm.$emit('qualification', id);
    },
    createOrder(details){
      let vm = this;
      vm.$emit('create', details)
    },
    setResult(){
      let vm = this;
      this.$nextTick(() => {
        vm.$refs.qualificationResult.result = vm.sqResult;
      })
    }
  },
};
</script>

<style lang="scss" scoped></style>
